import maInput from '@/components/input'

/**
 * @module
 * @name InputRadio
 * @extends Input
 */
export default {
  name: 'InputRadio',
  extends: maInput,
  /**
   * @property {Array=} options Options array. Option should contain at least key
   *                           and value.
   * @property {String=} icon VueSVGIcon name.
   */
  props: {
    options: {
      type: Array,
      required: false,
      default: []
    },
    icon: {
      type: String,
      required: false
    },
    selectFirst: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    selectFirstOption: function() {
      return this.selectFirst
    }
  },
  methods: {
    /**
     * @function
     * @name isChecked
     * @description Returns if inputKey matches with component selected value.
     * @param {inputKey} inputKey Object key.
     */
    isChecked: function (inputKey) {
      return this.value === inputKey
    },

    /**
     * @function
     * @name selectFirst
     * @description Find first element by value, and then, click it triggering
     *              all the events and consequent styles for it.
     */
    selectFirstElement: function () {
      const firstOptionKey = this.options[0].key
      const firstInput = document.querySelector(`input[value="${firstOptionKey}"]`)
      firstInput.click()
    },

    /**
     * @function
     * @name isChecked
     * @description Returns if inputKey matches with component selected value.
     * @param {inputKey} inputKey Object key.
     */
    handleClick: function (inputKey) {
      this.$emit('change', inputKey)
    }
  },

  /**
   * @function
   * @name mounted
   * @description If value doesn't exist, selects the first option.
   */
  mounted: function () {
    if (!this.value && this.selectFirstOption) {
      this.selectFirstElement()
    }
  }
}
